export const breakpoints = {
  mobile: '374',
  tablet: '559',
  desktop: '1025',
} as const;
